import { render, staticRenderFns } from "./titleheader.vue?vue&type=template&id=531f40b9&"
import script from "./titleheader.js?vue&type=script&lang=js&"
export * from "./titleheader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531f40b9')) {
      api.createRecord('531f40b9', component.options)
    } else {
      api.reload('531f40b9', component.options)
    }
    module.hot.accept("./titleheader.vue?vue&type=template&id=531f40b9&", function () {
      api.rerender('531f40b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/titleheader.vue"
export default component.exports